import { tns } from 'tiny-slider/src/tiny-slider';

/* document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.teaser-logo-slider__wrapper').forEach(
    $slideshow => tns({
      container: $slideshow,
      items: 1,
      slideBy: 'page',
      autoplay: false,
      controlsPosition: 'bottom',
      navPosition: 'bottom',
      autoplayButtonOutput: false,
      controlsContainer: '.teaser-logo-slider__controls',
      responsive: {
        768: {
          items: 3,
        },
      },
    }),
  );
}); */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.teaser-logo-slider').forEach(async (element) => {
    // eslint-disable-next-line no-unused-vars
    const slider = tns({
      container: element.querySelector('.teaser-logo-slider__wrapper'),
      items: 1,
      slideBy: 'page',
      autoplay: false,
      controlsPosition: 'bottom',
      navPosition: 'bottom',
      autoplayButtonOutput: false,
      controlsContainer: element.querySelector('.teaser-logo-slider__controls'),
      responsive: {
        768: {
          items: 3,
        },
      },
    });

    // Function to update tabindex dynamically
    const updateTabIndex = () => {
      document.querySelectorAll('.teaser-logo-slider__element').forEach((el) => {
        if (el.classList.contains('tns-slide-active')) {
          const link = el.querySelector('.teaser-logo__link');
          if (link) {
            link.setAttribute('tabindex', '0');
          }
          const cardBack = el.querySelector('.teaser_logo__card-back');
          if (cardBack) {
            cardBack.setAttribute('tabindex', '0');
          }
          el.querySelectorAll('a').forEach((a) => {
            a.setAttribute('tabindex', '0');
          });
        } else {
          const link = el.querySelector('.teaser-logo__link');
          if (link) {
            link.setAttribute('tabindex', '-1');
          }
          const cardBack = el.querySelector('.teaser_logo__card-back');
          if (cardBack) {
            cardBack.setAttribute('tabindex', '-1');
          }
          el.querySelectorAll('a').forEach((a) => {
            a.setAttribute('tabindex', '-1');
          });
        }
      });
      document.querySelectorAll('.tns-nav .tns-nav-active').forEach((navItem) => {
        navItem.setAttribute('tabindex', '-1');
      });
    };

    // Call the function initially and on index change
    updateTabIndex();
    slider.events.on('indexChanged', updateTabIndex);
  });
});
